import { render } from "./TagSearchAction.vue?vue&type=template&id=0f87d85a&scoped=true"
import script from "./TagSearchAction.vue?vue&type=script&lang=js"
export * from "./TagSearchAction.vue?vue&type=script&lang=js"

import "./TagSearchAction.vue?vue&type=style&index=0&id=0f87d85a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f87d85a"]])

export default __exports__